import { Component } from '@angular/core';
import { APP_NAME } from '../../utils/constants';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  sideBarWidth: number = 230;
}
